import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }
    static getDerivedStateFromError(error) { return { hasError: true, error }; }
    componentDidCatch(error, errorInfo) { console.error("Uncaught error:", error, errorInfo); }
    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen flex items-center justify-center bg-red-50 dark:bg-slate-900 p-6">
                    <div className="bg-white dark:bg-slate-800 p-8 rounded-xl shadow-xl border border-red-200 dark:border-red-900 max-w-lg">
                        <h2 className="text-2xl font-bold text-red-600 dark:text-red-400 mb-4">哎呀！出錯了 😵</h2>
                        <p className="text-slate-600 dark:text-slate-300 mb-4">應用程式遇到了一個未預期的錯誤。請嘗試重新整理。</p>
                        <div className="bg-slate-900 text-slate-200 p-4 rounded-lg font-mono text-xs overflow-auto mb-6 max-h-40">{this.state.error && this.state.error.toString()}</div>
                        <button onClick={() => window.location.reload()} className="w-full py-3 bg-red-600 text-white rounded-lg font-bold hover:bg-red-700 transition-colors">重新整理頁面</button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
